export default __webpack_public_path__ + "static/media/00.1c4e1b4f.jpg";